const initialState = {
    approved: [], 
    applied:[],
    allapplications:[],
    
  
  };
  
  const MOApplicationReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_APPROVED_SUCCESS':
            return {... state, approved:action.payload};
            case 'FETCH_APPLIED_SUCCESS':
            return {... state, applied:action.payload};
            case 'FETCH_ALL_SUCCESS':
            return {... state, allapplications:action.payload};
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default MOApplicationReducers;
  
  